module.exports = __webpack_public_path__ + "img/lens-160-plus-05.48152989.png";